export default "__VITE_ASSET__BrW95Ug5__"